import React from "react";
import { FormattedMessage } from "react-intl";
import ReactSVG from "react-svg";
import { commonMessages } from "@temp/intl";
import * as S from "./styles";

var closeImg = require("../../../../images/close.svg");

var ModalViewRoute = function ModalViewRoute(props) {
  var externalTraking = props.externalTraking,
      onClose = props.onClose;
  var trackingUrl = externalTraking === null || externalTraking === void 0 ? void 0 : externalTraking.replace(/['"]/g, "").trim();
  return React.createElement(S.Overlay, {
    onClick: onClose
  }, React.createElement(S.Modal, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, React.createElement(S.Header, null, React.createElement(S.Title, null, React.createElement(FormattedMessage, commonMessages.seeRoute)), React.createElement(S.CloseButton, {
    onClick: onClose
  }, React.createElement(ReactSVG, {
    path: closeImg
  }))), React.createElement(S.Content, null, trackingUrl ? React.createElement(S.TrackingFrame, {
    src: trackingUrl,
    title: "Seguimiento de entrega",
    allow: "geolocation"
  }) : React.createElement(S.NoDataContainer, null, React.createElement(S.NoDataText, null, React.createElement(FormattedMessage, {
    id: "@next.components.molecules.ModalViewRoute.ModalViewRoute.3002723941",
    defaultMessage: "No hay informaci\xF3n de seguimiento disponible"
  }))))));
};

export default ModalViewRoute;